import chalk from 'chalk';

export const highlighter = {
  error: chalk.red,
  warn: chalk.yellow,
  info: chalk.cyan,
  success: chalk.green,
};
